import React from 'react';
import Greeting from './Greeting';
import RegisterForm from '../auth/forms/RegisterForm';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const containerStyle = {
    marginTop: '10%',
    marginBottom: '10%',
};

const Landing = (props) => {
    const { isSignedIn } = props;
    // const appcom = isSignedIn ? <p>yyy</p> : <p>nnn</p>;

    if (isSignedIn) {
        return <Redirect to={ROUTES.HOME_PROJECTS} />;
    } else {
        return (
            <div>
                <div className="container" style={containerStyle}>
                    <div className="row">
                        <div className="col-sm-6">
                            {/* GREETING */}
                            <Greeting />
                            {/* {appcom} */}
                        </div>
                        <div className="col-sm-6">
                            {/* REGISTER FORM */}
                            <RegisterForm />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isSignedIn: !state.firebase.auth.isEmpty,
    }
}

export default connect(mapStateToProps)(Landing);
